import { render, staticRenderFns } from "./ReservationFormParams.vue?vue&type=template&id=45a2bc04&scoped=true&"
import script from "./ReservationFormParams.vue?vue&type=script&lang=js&"
export * from "./ReservationFormParams.vue?vue&type=script&lang=js&"
import style0 from "./ReservationFormParams.vue?vue&type=style&index=0&id=45a2bc04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a2bc04",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/ReservationFormParams.vue
// module id = null
// module chunks = 